var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Icon',_vm._b({staticClass:"fill-oth-5 hover:fill-oth-4 active:fill-gray-2"},'Icon',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }